import { shortenUrl } from '../../../utils/stringUtils';
import './GiftLink.scss';

interface GiftLinkProps {
    title: string;
    url: string;
    shortenUrl: boolean;
}

const GiftLink = (props: GiftLinkProps) => {
    const renderUrl = () => {
        const displayUrl = props.shortenUrl ? shortenUrl(props.url) : props.url;
        
        const queryIndex = displayUrl.indexOf('?');
        if (queryIndex === -1) {
            return displayUrl;
        }
        
        const baseUrl = displayUrl.substring(0, queryIndex);
        const queryString = displayUrl.substring(queryIndex);
        
        return (
            <>
                {baseUrl}
                <span className="gift-link-query">{queryString}</span>
            </>
        );
    };

    return (
        <>
            <span className="gift-link-title"><a href={props.url} target="_blank" rel="noreferrer">{props.title}</a></span><br />
            <span className="gift-link-url"><a href={props.url} target="_blank" rel="noreferrer">{renderUrl()}</a></span>
        </>
    );
}

export default GiftLink;